import { IconProps } from "./dto";

export function FiltersLinesIcon(props: IconProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 8H12M2 4H14M6 12H10" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}